import { CPFormSubmit } from '@warden-ui/common-components';
import { CPCard } from '@warden-ui/common-components';
import { useState } from 'react';
import { UserNameInput } from '@warden-ui/common-components';
import { useTranslation } from 'react-i18next';

interface CardContentUserUpdateProps {
  activeUser: boolean;
  teamDomain?: string;
  teamName?: string;
  onClickSave?: (firstname: string, lastname: string) => void;
  errorMessage?: string;
  loading?: boolean;
}

export const CardContentUserUpdate = ({
  activeUser,
  teamDomain = '',
  teamName = '',
  onClickSave = () => {},
  ...props
}: CardContentUserUpdateProps) => {
  const [t] = useTranslation();
  const title = activeUser
    ? t('user_update.active.title') 
    : t('user_update.inactive.title');
  const labelButton = activeUser
    ? t('user_update.active.action') 
    : t('user_update.inactive.action');

  const [firstname, setFirstname] = useState('');
  const [lastname, setLastname] = useState('');

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    onClickSave(firstname, lastname);
  };

  return (
    <CPCard>
      <CPFormSubmit
        title={title}
        titleClassName="mb-2"
        hint={teamDomain}
        labelButton={labelButton}
        loading={props.loading}
        handleSubmit={handleSubmit}
        disabled={firstname === '' || lastname === ''}
      >
        <span className="cp-hint">{t('user_update.hint', {teamName})}</span>

        <UserNameInput
          firstname={firstname}
          lastname={lastname}
          onFirstnameChange={(val) => setFirstname(val)}
          onLastnameChange={(val) => setLastname(val)}
          className='mb-4 mt-4'
        />
      </CPFormSubmit>
    </CPCard>
  );
};
